<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÕES ALINHADOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <div class="logo mb-24 mb-md-0"
                     fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        business
                    </mat-icon>
                    <span class="logo-text h1">
                        Acompanhamento de Operações RV
                    </span>
                </div>

                <!-- BOTÃO CONSULTAR ALINHADO AO LADO DO TÍTULO -->
                <button mat-mini-fab 
                        color="accent"
                        matTooltip="Consultar Operações"
                        (click)="openFiltro()"
                        style="margin-left: 16px;">
                    <mat-icon>search</mat-icon>
                </button>
            </div>
            <!-- / TÍTULO E BOTÕES ALINHADOS -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card"> 
            <ngx-datatable 
                #table 
                class='material striped' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns"
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'"                
                (sort)="onSort($event)"
                [rows]='rows'>

                <ngx-datatable-column name="Estratégia" prop="estrategia" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-estrategia="value" ngx-datatable-cell-template>
                        {{estrategia.nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Data Início" prop="data_inicio" [sortable]="false" [width]="50">
                    <ng-template let-rowIndex="rowIndex" let-data_inicio="value" ngx-datatable-cell-template>
                        {{data_inicio | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="false" [width]="50"> 
                    <ng-template let-rowIndex="rowIndex" let-ativo="value" ngx-datatable-cell-template>
                        {{ativo.sigla}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Preço Med. Compra" prop="preco_medio_compra" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-preco_medio_compra="value" ngx-datatable-cell-template>
                        {{ preco_medio_compra | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Preço Med. Venda" prop="preco_medio_venda" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-preco_medio_venda="value" ngx-datatable-cell-template>
                        {{ preco_medio_venda | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ganho(%)" prop="percentual" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-percentual="value" ngx-datatable-cell-template>
                        {{ percentual | number : '1.2-2' }} %
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Vol. Financeiro" prop="volume_financeiro" [sortable]="false" [width]="150">
                    <ng-template let-rowIndex="rowIndex" let-volume_financeiro="value" ngx-datatable-cell-template>
                        R$ {{ volume_financeiro.valor | number : '1.2-2' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Qtd. Trades" prop="qtd_clientes" [sortable]="false" [width]="50">
                    <ng-template let-rowIndex="rowIndex" let-qtd_clientes="value" ngx-datatable-cell-template>
                        {{ qtd_clientes | number : '1.0-0' }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Trades Finalizados" prop="qtd_trades_finalizados" [sortable]="false" [width]="50">
                    <ng-template let-rowIndex="rowIndex" let-qtd_trades_finalizados="value" ngx-datatable-cell-template>
                        {{ qtd_trades_finalizados | number : '1.0-0' }}
                    </ng-template>
                </ngx-datatable-column>                

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false" [width]="80">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Visualizar Trades" (click)="openVisualizar(id)">
                            <mat-icon aria-label="Visualizar Trades">search</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>